import api from "../api";
import { UserType } from "../context/hooks/useUserType";

export const createUsersGat = async (Users: UserType): Promise<boolean> => {
    const result = await api.post(`/users/`, Users);
    if (result.status === 200) {
      return result.data;
    } else {
      throw new Error("Não foi possível cadastrar usuário. Este email já está sendo utilizado!");
    }
};

export const updateUsersGat = async (Users: UserType): Promise<boolean> => {
    const result = await api.put(`/users/`, Users);
    if (result.status === 200) {
      return result.data;
    } else {
      throw new Error("Não foi possível atualizar usuário.");
    }
};

export const getUsersByIdGat = async (usersId: string): Promise<any> => {
  try {
    const response = await api.get(`/users/${usersId}`);
    if (response && response.data) {
      return response.data;
    } else {
      throw new Error("Não foi possível obter os dados do usuário.");
    }
  } catch (error) {
    throw new Error("Erro ao buscar usuário: ");
  }
};

export const validateEmailGat = async (email: string): Promise<any> => {
  try {
    const response = await api.get(`/users/validate_email?email=${email}`);
    if (response && response.data) {
      return response.data;
    } else {
      throw new Error("Não foi possível obter os dados do usuário.");
    }
  } catch (error) {
    throw new Error("Erro ao buscar usuário: ");
  }
};

export const getAllUsersGat = async (pageNumber: number, name?: string, pageSize: number = 50): Promise<any> => {
  try {

    let url = `/Users?`;

    if (pageNumber && pageNumber !== 0) {
      url = url + `pageNumber=${pageNumber}`;
    }

    if(pageSize && pageSize !== 0) {
      url =url + `&pageSize=${pageSize}`
    }

    if (name) {
      url = url + `&Name=${name}`;
    }

    const response = await api.get(url);

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error("Não foi possível obter os dados dos usuários.");
    }
  } catch (error) {
    throw new Error("Erro ao buscar usuários: ");
  }
};


export const deleteUsersGat = async (UsersId: number): Promise<boolean> => {
  try {
    const response = await api.delete(`/Users/${UsersId}`);
    if (response) {
      return true;
    } else {
      throw new Error("Não foi possível obter os dados do usuário.");
    }
  } catch (error) {
    throw new Error("Erro ao buscar usuário: ");
  }
};

export const reactivateUsersGat = async (UsersId: number): Promise<boolean> => {
  try {
    const response = await api.put(`/Users/reactivate-user/${UsersId}`);
    if (response) {
      return true;
    } else {
      throw new Error("Não foi possível atualizar os dados do usuário.");
    }
  } catch (error) {
    throw new Error("Erro ao buscar usuário: ");
  }
};

export const sendVerificationCodeGat = async (email: string): Promise<string> => {
  try {

    const result = await api.post(`/Users/send-verification-code`, email);
    if (result) {
      var resultString = result.data.toString();
      return result.data;
    } else {
      throw new Error("Não foi possível enviar o código de verificação.");
    }
  } catch (error) {
    throw new Error("Erro ao enviar o código de verificação.");
  }
};

export const getAllUsersToExcelGat = async (): Promise<Blob> => {
  try {
    const response = await api.get('Users/GetAllToExcel/', {
      responseType: 'blob'  // Define que a resposta será um blob
    });

    if (response) {
      return response.data;  // Retorna o blob
    } else {
      throw new Error("Não foi possível obter os dados.");
    }
  } catch (error) {
    throw new Error("Erro ao buscar: ");
  }
};